import { shape } from '../shape';
export var MuiSnackbar = {
    styleOverrides: {
        root: {
            '& [class*=MuiAlert-root]': {
                borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
                boxShadow: '0px 3px 6px #0000004D',
            },
        },
    },
};
